import { ValidatorFn, AbstractControl } from '@angular/forms';

export class PasswordValidation {

    static MatchPassword(AC: AbstractControl) {
        let password = AC.get('password').value; // to get value in input tag
        let confirmPassword = AC.get('repassword').value; // to get value in input tag
         if(password != confirmPassword) {
            AC.get('repassword').setErrors( {MatchPassword: true} )
         } else {
             return null
         }
     } 
}

export const regExps: { [key: string]: RegExp } = {
    password: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[$@$!%*?&])[A-Za-z\d$@$!%*?&]{8,}$/ ,
    uppercase: /[A-Z]/,
    lowercase:/[a-z]/,
    number: /[0-9]/,
    symbol:/[ !"#$%&'()*+,-./:;<=>?@[\\\]^_`{\|}~]/
}



// WEBPACK FOOTER //
// ./src/app/components/register-form/password-validation.ts